

export const authCheckOne = (state = false, action) => { 
    switch (action.type) {
        case 'AUTH_CHECK_ONE_CHANGE':
            return action.value;      
        default:
            return state
    }
}
export const authCheckOnePartTwo = (state = false, action) => { 
    switch (action.type) {
        case 'AUTH_CHECK_ONE_PART_TWO_CHANGE':
            return action.value;      
        default:
            return state
    }
}
export const authName = (state = '', action) => { 
    switch (action.type) {
        case 'AUTH_NAME_CHANGE':
            return action.value;      
        default:
            return state
    }
}
export const authSurname = (state = '', action) => { 
    switch (action.type) {
        case 'AUTH_SURNAME_CHANGE':
            return action.value;      
        default:
            return state
    }
}
export const authAddress = (state = '', action) => { 
    switch (action.type) {
        case 'AUTH_ADDRESS_CHANGE':
            return action.value;      
        default:
            return state
    }
}
export const authPesel = (state = '', action) => { 
    switch (action.type) {
        case 'AUTH_PESEL_CHANGE':
            return action.value;      
        default:
            return state
    }
}
export const authId = (state = '', action) => { 
    switch (action.type) {
        case 'AUTH_ID_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const authCheckTwo = (state = false, action) => { 
    switch (action.type) {
        case 'AUTH_CHECK_TWO_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const authCheckThree = (state = false, action) => { 
    switch (action.type) {
        case 'AUTH_CHECK_THREE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const authCheckFour = (state = false, action) => { 
    switch (action.type) {
        case 'AUTH_CHECK_FOUR_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const authCheckFive = (state = false, action) => { 
    switch (action.type) {
        case 'AUTH_CHECK_FIVE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const authCheckSix = (state = false, action) => { 
    switch (action.type) {
        case 'AUTH_CHECK_SIX_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const authCheckSeven = (state = false, action) => { 
    switch (action.type) {
        case 'AUTH_CHECK_SEVEN_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const authCheckEight = (state = false, action) => { 
    switch (action.type) {
        case 'AUTH_CHECK_EIGHT_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const attachmentsFiles = (state = [], action) => { 
    switch (action.type) {
        case 'ATTACHMENTS_FILES_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const comments = (state = [], action) => { 
    switch (action.type) {
        case 'COMMENTS_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const postman = (state = '', action) => { 
    switch (action.type) {
        case 'POSTMAN_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const emailbill = (state = '', action) => { 
    switch (action.type) {
        case 'EMAILBILL_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const esign = (state = false, action) => { 
    switch (action.type) {
        case 'ESIGN_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const esignForceVisible = (state = false, action) => { 
    switch (action.type) {
        case 'ESIGN_FORCEVISIBLE_CHANGE':
            return action.value;      
        default:
            return state
    }
}



const initalState = {
    esignPersons: [{
        name: '',
        surname: '',
        email: '',
        phone: '',
    }]
}

export const esignPersons = (state = initalState.esignPersons, action) => { 
    switch (action.type) {
        case 'ESIGN_PERSONS_CHANGE':
            return action.value;      
        default:
            return state
    }
}
